module.exports = __webpack_public_path__ + "static/media/visitbrussels_2.7adabe15.jpg";